import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, ContentChildren, NgModule } from '@angular/core';
import { CapturumTemplateDirective } from '@capturum/ui/api';
import * as i1 from 'primeng/sidebar';
import { SidebarModule } from 'primeng/sidebar';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["sidebar"];
function CapturumSidebarComponent_div_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CapturumSidebarComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "hr");
    i0.ɵɵtemplate(2, CapturumSidebarComponent_div_7_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
const _c1 = ["*"];
let CapturumSidebarComponent = /*#__PURE__*/(() => {
  class CapturumSidebarComponent {
    set visible(value) {
      if (value !== this._visible) {
        this._visible = value;
        if (!value && this.sidebarComponent) {
          // trigger primeng sidebar close event
          this.sidebarComponent.close(new Event('click'));
        }
      }
    }
    get visible() {
      return this._visible;
    }
    constructor(cdr) {
      this.cdr = cdr;
      this.position = 'right';
      this.visibleChange = new EventEmitter();
      this.sidebarClose = new EventEmitter();
    }
    ngAfterViewInit() {
      this.subscription = this.sidebarComponent.visibleChange?.subscribe(visible => {
        this.visibleChange.emit(visible);
      });
      const footerTemplate = this.templates.find(template => template.getType() === 'footer');
      if (footerTemplate) {
        this.footerTemplate = footerTemplate.template;
      }
      this.cdr.detectChanges();
    }
    ngOnDestroy() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
    closeSidebar(event) {
      if (event) {
        this.sidebarComponent?.close(event);
        this.sidebarClose.emit(true);
      }
      this.visible = false;
    }
    static {
      this.ɵfac = function CapturumSidebarComponent_Factory(t) {
        return new (t || CapturumSidebarComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumSidebarComponent,
        selectors: [["cap-sidebar"]],
        contentQueries: function CapturumSidebarComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        viewQuery: function CapturumSidebarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sidebarComponent = _t.first);
          }
        },
        inputs: {
          visible: "visible",
          title: "title",
          styleClass: "styleClass",
          position: "position",
          style: "style"
        },
        outputs: {
          visibleChange: "visibleChange",
          sidebarClose: "sidebarClose"
        },
        ngContentSelectors: _c1,
        decls: 8,
        vars: 10,
        consts: [[3, "visible", "position", "styleClass", "showCloseIcon", "visibleChange", "onHide"], ["sidebar", ""], [1, "cap-sidebar-header"], [1, "fas", "fa-times", 3, "click"], [1, "cap-sidebar-content"], ["class", "cap-sidebar-footer", 4, "ngIf"], [1, "cap-sidebar-footer"], [4, "ngTemplateOutlet"]],
        template: function CapturumSidebarComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r3 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "p-sidebar", 0, 1);
            i0.ɵɵlistener("visibleChange", function CapturumSidebarComponent_Template_p_sidebar_visibleChange_0_listener($event) {
              return ctx.visible = $event;
            })("onHide", function CapturumSidebarComponent_Template_p_sidebar_onHide_0_listener() {
              i0.ɵɵrestoreView(_r3);
              const _r0 = i0.ɵɵreference(1);
              return i0.ɵɵresetView(_r0.destroyModal());
            });
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementStart(4, "i", 3);
            i0.ɵɵlistener("click", function CapturumSidebarComponent_Template_i_click_4_listener($event) {
              return ctx.closeSidebar($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, CapturumSidebarComponent_div_7_Template, 3, 1, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
            i0.ɵɵproperty("visible", ctx.visible)("position", ctx.position)("styleClass", ctx.styleClass)("showCloseIcon", false);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("has-footer", ctx.footerTemplate);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.footerTemplate);
          }
        },
        dependencies: [i1.Sidebar, i2.NgIf, i2.NgTemplateOutlet],
        encapsulation: 2
      });
    }
  }
  return CapturumSidebarComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumSidebarModule = /*#__PURE__*/(() => {
  class CapturumSidebarModule {
    static {
      this.ɵfac = function CapturumSidebarModule_Factory(t) {
        return new (t || CapturumSidebarModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumSidebarModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [SidebarModule, CommonModule]
      });
    }
  }
  return CapturumSidebarModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumSidebarComponent, CapturumSidebarModule };
